<template>
  <div class=" overflow-auto">
    <table class="table table-xs md:table-sm xl:table-md" v-if="persons.length">
      <thead>
        <tr>
          <th>#</th>
          <th> {{ __('Full Name') }} </th>
          <th> {{ __('Phone number') }} </th>
          <th> {{ __('Email') }} </th>
          <th> {{ __('Account name') }} </th>
          <th> {{ __('User') }} </th>
          <th> {{ __('Created At') }} </th>
          <th> {{ __('Action') }} </th>
        </tr>

      </thead>
      <tbody>
        <tr v-for="(item, index) in persons">
          <td>{{ (meta.per_page ?? 1) * ((meta.current_page ?? 1) - 1) + index + 1 }}</td>
          <td> {{ item.name }} </td>
          <td> {{ item.phone || '---' }} </td>
          <td> {{ item.email || '---' }} </td>
          <td> {{ item.account_name }} </td>
          <td> {{ item.user }} </td>
          <td> {{ item.created_at }}</td>
          <td>
            <router-link :to="{ name: 'user.person.show', params: { id: item.id } }"
              :class="{ 'btn-disabled': !can('person.view.all') && !can('person.view.self', item.self) }"
              class="btn btn-outline btn-primary btn-sm ml-2">
              {{ __('Show') }}
            </router-link>
            <router-link :to="{ name: 'user.person.edit', params: { id: item.id } }"
              :class="{ 'btn-disabled': !can('person.delete.all') && !can('person.delete.self', item.self) }"
              class="btn btn-outline btn-info btn-sm ml-2">
              {{ __('Edit') }}
            </router-link>
            <label @click="setItem(item)" for="person-delete-modal"
              :class="{ 'btn-disabled': !can('person.delete.all') && !can('person.delete.self', item.self) }"
              class="btn btn-outline btn-error btn-sm">
              {{ __('Delete') }}
            </label>
          </td>
        </tr>
      </tbody>
    </table>
    <div class="col-span-12 flex flex-col items-center mt-9" v-else>
      <NotFound />
    </div>
  </div>
</template>
<script setup>
const {
  meta,
} = useDashboard();
defineProps(["persons"]);
const emit = defineEmits(["setItem"]);
const setItem = (item) => emit("setItem", item);
</script>